import React, { useCallback, useEffect, FunctionComponent} from "react";
import { Card, Row, Col, Collapse } from "antd";
import { StoreType } from "../../../redux/store";
import { connect } from "react-redux";
import moment from "moment";
import LoadingGraph from "../../../wrappers/LoadingGraph";
import PropTypes from "prop-types";
import {
  PartnersSendingAdsRecord,
  AverageAdsPerPartnerRecord,
  ProcessedOrigamiAdsByGroupRecord,
  StartedOrigamiAdsByPublicationRecord
} from "../../../redux/types/reportTypes";
import fetchBilledAdsWtd, {
  FetchBilledAdsWtd
} from "../../../redux/actions/reports/fetchAdsWtd";
import fetchBilledAdsLwtd, {
  FetchBilledAdsLwtd
} from "../../../redux/actions/reports/fetchBilledAdsLwtd";
import fetchBilledAdsMtd, {
  FetchBilledAdsMtd
} from "../../../redux/actions/reports/fetchBilledAdsMtd";
import fetchBilledAdsLmtd, {
  FetchBilledAdsLmtd
} from "../../../redux/actions/reports/fetchBilledAdsLmtd";
import fetchReceivedAdsWtd, {
  FetchReceivedAdsWtd
} from "../../../redux/actions/reports/fetchReceivedAdsWtd";
import fetchReceivedAdsLwtd, {
  FetchReceivedAdsLwtd
} from "../../../redux/actions/reports/fetchReceivedAdsLwtd";
import fetchReceivedAdsMtd, {
  FetchReceivedAdsMtd
} from "../../../redux/actions/reports/fetchReceivedAdsMtd";
import fetchReceivedAdsLmtd, {
  FetchReceivedAdsLmtd
} from "../../../redux/actions/reports/fetchReceivedAdsLmtd";
import fetchPartnersSendingAds, {
  FetchPartnersSendingAds
} from "../../../redux/actions/reports/fetchPartnersSendingAds";
import fetchAverageAdsPerPartner, {
  FetchAverageAdsPerPartner
} from "../../../redux/actions/reports/fetchAverageAdsPerPartner";
import fetchProcessedAdsByGroup, {
  FetchProcessedAdsByGroup
} from '../../../redux/actions/reports/fetchProcessedAdsByGroup'
import fetchStartedAdsByPublication, {
  FetchStartedAdsByPublication
} from '../../../redux/actions/reports/fetchStartedAdsByPublication'
import AdsTrackerStatistics from "../AdTrackerStatistics"
import PartnersSendingAds from '../PartnersSendingAdsGraph'
import AverageAdsPerPartners from '../AverageAdsPerPartnersGraph'
import ProcessedOrigamiAdsByGroupTable from '../ProcessedAdsByGroupTable'
import StartedOrigamiAdsByPublicationTable from '../StartedAdsByPublicationTable'

type RecordOptions = 
  | ProcessedOrigamiAdsByGroupRecord
  | StartedOrigamiAdsByPublicationRecord;
export const rowClassName = (record: RecordOptions): string => {
  let className = "";
  if (record.wtd_diff < 0) className += "down-wtd-diff";
  else if (record.wtd_diff > 0) className += "up-wtd-diff";
  if (record.wtd_perc_diff < 0) className += " down-wtd-perc-diff";
  else if (record.wtd_perc_diff > 0) className += " up-wtd-perc-diff";
  if (record.mtd_diff < 0) className += "down-mtd-diff";
  else if (record.mtd_diff > 0) className += "up-mtd-diff";
  if (record.mtd_perc_diff < 0) className += " down-mtd-perc-diff";
  else if (record.mtd_perc_diff > 0) className += " up-mtd-perc-diff";
  if (record.qtd_diff < 0) className += "down-qtd-diff";
  else if (record.qtd_diff > 0) className += "up-qtd-diff";
  if (record.qtd_perc_diff < 0) className += " down-qtd-perc-diff";
  else if (record.qtd_perc_diff > 0) className += " up-qtd-perc-diff";
  return className;
};

type OrigamiAdsProps = {
  billedAdsWtd: number;
  billedAdsLwtd: number;
  billedAdsMtd: number;
  billedAdsLmtd: number;
  receivedAdsWtd: number;
  receivedAdsLwtd: number;
  receivedAdsMtd: number;
  receivedAdsLmtd: number;
  billedWtdLoading: boolean;
  adsLwtdLoading: boolean;
  adsMtdLoading: boolean;
  adsLmtdLoading: boolean;
  receivedWtdLoading: boolean;
  receivedLwtdLoading: boolean;
  receivedMtdLoading: boolean;
  receivedLmtdLoading: boolean;
  partnerSendingAdsLoading: boolean;
  avgAdsPerPartnerLoading: boolean;
  processedOrigamiAdsByGroupLoading: boolean;
  startedOrigamiAdsByPublicationLoading: boolean;
  fetchBilledAdsWtd: FetchBilledAdsWtd;
  fetchBilledAdsLwtd: FetchBilledAdsLwtd;
  fetchBilledAdsMtd: FetchBilledAdsMtd;
  fetchBilledAdsLmtd: FetchBilledAdsLmtd;
  fetchReceivedAdsWtd: FetchReceivedAdsWtd;
  fetchReceivedAdsLwtd: FetchReceivedAdsLwtd;
  fetchReceivedAdsMtd: FetchReceivedAdsMtd;
  fetchReceivedAdsLmtd: FetchReceivedAdsLmtd;
  fetchPartnersSendingAds: FetchPartnersSendingAds;
  fetchAverageAdsPerPartner: FetchAverageAdsPerPartner;
  fetchProcessedAdsByGroup: FetchProcessedAdsByGroup;
  fetchStartedAdsByPublication: FetchStartedAdsByPublication;
  partnerSendingAdsRecords: Array<PartnersSendingAdsRecord>;
  avgAdsPerPartnerRecords: Array<AverageAdsPerPartnerRecord>;
  processedOrigamiAdsByGroupRecord: Array<ProcessedOrigamiAdsByGroupRecord>;
  startedOrigamiAdsByPublicationRecord: Array<StartedOrigamiAdsByPublicationRecord>
};

const initialFilters = () => {
  const endDate = moment();
  const startDate = moment().add(-1, "month");
  return { startDate, endDate };
};

export const OrigamiAds: FunctionComponent<OrigamiAdsProps> = ({
  billedWtdLoading,
  billedAdsWtd,
  adsLwtdLoading,
  billedAdsLwtd,
  adsMtdLoading,
  billedAdsMtd,
  adsLmtdLoading,
  billedAdsLmtd,
  receivedWtdLoading,
  receivedAdsWtd,
  receivedLwtdLoading,
  receivedAdsLwtd,
  receivedMtdLoading,
  receivedAdsMtd,
  receivedLmtdLoading,
  receivedAdsLmtd,
  partnerSendingAdsLoading,
  partnerSendingAdsRecords,
  avgAdsPerPartnerLoading,
  avgAdsPerPartnerRecords,
  fetchBilledAdsWtd,
  fetchBilledAdsLwtd,
  fetchBilledAdsMtd,
  fetchBilledAdsLmtd,
  fetchReceivedAdsWtd,
  fetchReceivedAdsLwtd,
  fetchReceivedAdsMtd,
  fetchReceivedAdsLmtd,
  fetchPartnersSendingAds,
  fetchAverageAdsPerPartner,
  fetchProcessedAdsByGroup,
  fetchStartedAdsByPublication,
  processedOrigamiAdsByGroupRecord,
  processedOrigamiAdsByGroupLoading,
  startedOrigamiAdsByPublicationLoading,
  startedOrigamiAdsByPublicationRecord,
}: OrigamiAdsProps) => {
  const setInitialState = useCallback(() => {
    const initial = initialFilters();
    fetchBilledAdsWtd({...initial, report: "billed_origami_ads_wtd"});
    fetchBilledAdsLwtd({...initial, report: "billed_origami_ads_lwtd"});
    fetchBilledAdsMtd({...initial, report: "billed_origami_ads_mtd"});
    fetchBilledAdsLmtd({...initial, report: "billed_origami_ads_lmtd"});
    fetchReceivedAdsWtd({...initial, report: "received_origami_ads_wtd"});
    fetchReceivedAdsLwtd({...initial, report: "received_origami_ads_lwtd"});
    fetchReceivedAdsMtd({...initial, report: "received_origami_ads_mtd"});
    fetchReceivedAdsLmtd({...initial, report: "received_origami_ads_lmtd"});
    fetchPartnersSendingAds({...initial, report: "partners_sending_origami_ads"});
    fetchAverageAdsPerPartner({...initial, report: "average_origami_ads_per_partner"});
    fetchProcessedAdsByGroup({...initial, report: "processed_origami_ads_by_group"});
    fetchStartedAdsByPublication({...initial, report: "started_origami_ads_by_publication"});
  }, [fetchBilledAdsWtd, fetchBilledAdsLwtd, fetchBilledAdsMtd, fetchBilledAdsLmtd, fetchReceivedAdsWtd, fetchReceivedAdsLwtd, fetchReceivedAdsMtd, fetchReceivedAdsLmtd, fetchPartnersSendingAds, fetchAverageAdsPerPartner, fetchProcessedAdsByGroup, fetchStartedAdsByPublication]);

  useEffect(() => {
    setInitialState();
  }, [setInitialState]);

  return(
    <Card title="Origami ads">
      <Row>
        <Col span={12}>
          <Card title="Billed Ads">
            <AdsTrackerStatistics
              adsWtdTitle="ADS WTD"
              adsWtdLoading={billedWtdLoading}
              adsWtdValue={billedAdsWtd}
              adsLwtdTitle="ADS LWTD"
              adsLwtdLoading={adsLwtdLoading}
              adsLwtdValue={billedAdsLwtd}
              adsMtdTitle="ADS MTD"
              adsMtdLoading={adsMtdLoading}
              adsMtdValue={billedAdsMtd}
              adsLmtdTitle="ADS LMTD"
              adsLmtdLoading={adsLmtdLoading}
              adsLmtdValue={billedAdsLmtd}
            />
          </Card>
        </Col>
        <Col span={12}>
          <Card title="Received Ads">
            <AdsTrackerStatistics
              adsWtdTitle="ADS WTD"
              adsWtdLoading={receivedWtdLoading}
              adsWtdValue={receivedAdsWtd}
              adsLwtdTitle="ADS LWTD"
              adsLwtdLoading={receivedLwtdLoading}
              adsLwtdValue={receivedAdsLwtd}
              adsMtdTitle="ADS MTD"
              adsMtdLoading={receivedMtdLoading}
              adsMtdValue={receivedAdsMtd}
              adsLmtdTitle="ADS LMTD"
              adsLmtdLoading={receivedLmtdLoading}
              adsLmtdValue={receivedAdsLmtd}
            />
          </Card>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <LoadingGraph
            title="Partners Sending Ads"
            loading={partnerSendingAdsLoading}
            records={partnerSendingAdsRecords}
            Component={PartnersSendingAds}
            Extra={() => null}
          />
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <LoadingGraph
            title="Average Ads Per Partner"
            loading={avgAdsPerPartnerLoading}
            records={avgAdsPerPartnerRecords}
            Component={AverageAdsPerPartners}
            Extra={() => null}
          />
        </Col>
      </Row>
      <div className="accordion-container">
        <Collapse defaultActiveKey={["1", "2", "3", "4"]}>
          <Collapse.Panel header="Processed Origami Ads By Group" key="1" extra={null}>
            <ProcessedOrigamiAdsByGroupTable records={processedOrigamiAdsByGroupRecord} loading={processedOrigamiAdsByGroupLoading} />
          </Collapse.Panel>
          <Collapse.Panel header="Started Origami Ads By Publication" key="2" extra={null}>
            <StartedOrigamiAdsByPublicationTable records={startedOrigamiAdsByPublicationRecord} loading={startedOrigamiAdsByPublicationLoading} />
          </Collapse.Panel>
        </Collapse>
        
      </div>
    </Card>
  )
};

const mapDispatchToProps = {
  fetchBilledAdsWtd,
  fetchBilledAdsLwtd,
  fetchBilledAdsMtd,
  fetchBilledAdsLmtd,
  fetchReceivedAdsWtd,
  fetchReceivedAdsLwtd,
  fetchReceivedAdsMtd,
  fetchReceivedAdsLmtd,
  fetchPartnersSendingAds,
  fetchAverageAdsPerPartner,
  fetchProcessedAdsByGroup,
  fetchStartedAdsByPublication,
};

const mapStateToProps = ({
  reports: {
    billed_origami_ads_wtd: { loading: billedWtdLoading, records: billedAdsWtdRecords },
    billed_origami_ads_lwtd: { loading: adsLwtdLoading, records: billedAdsLwtdRecords },
    billed_origami_ads_mtd: { loading: adsMtdLoading, records: billedAdsMtdRecords },
    billed_origami_ads_lmtd: { loading: adsLmtdLoading, records: billedAdsLmtdRecords },
    received_origami_ads_wtd: { loading: receivedWtdLoading, records: receivedAdsWtdRecords },
    received_origami_ads_lwtd: { loading: receivedLwtdLoading, records: receivedAdsLwtdRecords },
    received_origami_ads_mtd: { loading: receivedMtdLoading, records: receivedAdsMtdRecords },
    received_origami_ads_lmtd: { loading: receivedLmtdLoading, records: receivedAdsLmtdRecords },
    partners_sending_origami_ads: { loading: partnerSendingAdsLoading, records: partnerSendingAdsRecords },
    average_origami_ads_per_partner: { loading: avgAdsPerPartnerLoading, records: avgAdsPerPartnerRecords },
    processed_origami_ads_by_group: { loading: processedOrigamiAdsByGroupLoading, records: processedOrigamiAdsByGroupRecord },
    started_origami_ads_by_publication: { loading: startedOrigamiAdsByPublicationLoading, records: startedOrigamiAdsByPublicationRecord },
  },
}: StoreType) => ({
  billedWtdLoading,
  adsLwtdLoading,
  adsMtdLoading,
  adsLmtdLoading,
  receivedWtdLoading,
  receivedLwtdLoading,
  receivedMtdLoading,
  receivedLmtdLoading,
  partnerSendingAdsLoading,
  avgAdsPerPartnerLoading,
  startedOrigamiAdsByPublicationLoading,
  billedAdsWtd: billedAdsWtdRecords[0]?.count,
  billedAdsLwtd: billedAdsLwtdRecords[0]?.count,
  billedAdsMtd: billedAdsMtdRecords[0]?.count,
  billedAdsLmtd: billedAdsLmtdRecords[0]?.count,
  receivedAdsWtd: receivedAdsWtdRecords[0]?.count,
  receivedAdsLwtd: receivedAdsLwtdRecords[0]?.count,
  receivedAdsMtd: receivedAdsMtdRecords[0]?.count,
  receivedAdsLmtd: receivedAdsLmtdRecords[0]?.count,
  partnerSendingAdsRecords,
  avgAdsPerPartnerRecords,
  processedOrigamiAdsByGroupLoading,
  processedOrigamiAdsByGroupRecord,
  startedOrigamiAdsByPublicationRecord,
});

OrigamiAds.propTypes = {
  fetchBilledAdsWtd: PropTypes.func.isRequired,
  fetchBilledAdsLwtd: PropTypes.func.isRequired,
  fetchBilledAdsMtd: PropTypes.func.isRequired,
  fetchBilledAdsLmtd: PropTypes.func.isRequired,
  fetchReceivedAdsWtd: PropTypes.func.isRequired,
  fetchReceivedAdsLwtd: PropTypes.func.isRequired,
  fetchReceivedAdsMtd: PropTypes.func.isRequired,
  fetchReceivedAdsLmtd: PropTypes.func.isRequired,
  fetchPartnersSendingAds: PropTypes.func.isRequired,
  partnerSendingAdsLoading: PropTypes.bool.isRequired,
  partnerSendingAdsRecords: PropTypes.array.isRequired,
  fetchAverageAdsPerPartner: PropTypes.func.isRequired,
  avgAdsPerPartnerLoading: PropTypes.bool.isRequired,
  avgAdsPerPartnerRecords: PropTypes.array.isRequired,
  processedOrigamiAdsByGroupRecord: PropTypes.array.isRequired,
  processedOrigamiAdsByGroupLoading: PropTypes.bool.isRequired,
  fetchProcessedAdsByGroup: PropTypes.func.isRequired,
  fetchStartedAdsByPublication: PropTypes.func.isRequired,
  startedOrigamiAdsByPublicationLoading: PropTypes.bool.isRequired,
  startedOrigamiAdsByPublicationRecord: PropTypes.array.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrigamiAds);
